import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";

import { db } from "../lib/firebase";

export function useBlockedUsers(uid?: string | null) {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    if (!uid) {
      setIds([]);
      return;
    }

    const unsub = onSnapshot(
      collection(db, "users", uid, "blockedUsers"),
      (snap) => {
        setIds(snap.docs.map((item) => item.id).filter(Boolean));
      },
      () => setIds([])
    );

    return () => unsub();
  }, [uid]);

  return useMemo(() => new Set(ids), [ids]);
}
